export default function PaymentStatusFilter({ value, onChange, includeClosed = false }) {
  return <label className="mx-3 my-2 inline-flex items-center gap-2 text-sm text-slate-700">상태
    <select aria-label="결제 상태" value={value} onChange={event => onChange(event.target.value)} className="rounded-lg border border-slate-200 bg-white px-3 py-2">
      <option value="">전체</option><option value="COMPLETED">승인</option><option value="CANCELED">취소</option><option value="FAILED">실패</option><option value="UNKNOWN">결과 확인 필요</option>
      {includeClosed && <option value="CLOSED_BY_USER">결제창 종료</option>}
    </select>
  </label>;
}
